import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { ShieldCheck, Clock, Users } from "lucide-react";
import ReactMarkdown from 'react-markdown';
import { useLanguage } from "../context/LanguageContext";

export default function AboutUs() {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-neutral-950 text-white pt-20">
      {/* Header */}
      <section className="py-20 bg-black border-b border-neutral-800">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 text-white">{t.about.title_start} <span className="text-red-600">{t.about.title_end}</span></h1>
          <p className="text-xl text-neutral-400 max-w-2xl mx-auto">
            {t.about.subtitle}
          </p>
        </div>
      </section>

      {/* Story */}
      <section className="py-20">
        <div className="container mx-auto px-4 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_71ec9cde-94ef-481f-b20e-e9fde84e406a/artifacts/gjd9j9q7_Soccerplex%20cata.webp" 
              alt="Catalogna Soccerplex" 
              className="rounded-2xl shadow-2xl shadow-red-900/20"
            />
          </div>
          <div className="space-y-6">
            <h2 className="text-3xl font-bold text-white">{t.about.story_title}</h2>
            <p className="text-neutral-400 text-lg leading-relaxed">
              {t.about.story_p1}
            </p>
            <p className="text-neutral-400 text-lg leading-relaxed">
              {t.about.story_p2}
            </p>
            <p className="text-neutral-400 text-lg leading-relaxed">
              {t.about.story_p3}
            </p>
            <div className="grid grid-cols-2 gap-4 pt-4">
              <div className="flex items-center gap-2">
                <ShieldCheck className="text-red-600" />
                <span className="font-semibold">{t.about.licensed}</span>
              </div>
              <div className="flex items-center gap-2">
                <Clock className="text-red-600" />
                <span className="font-semibold">{t.about.ontime}</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
